export const ADVERTS_PER_SEARCH = 5;

export const TRANS_CATEGORY_ID = 12;

export const AdvertPlaceholder = {
    CLICK_ID: '$$click_id$$',
};

export const StripChatTag = {
    TRANS: 'trans',
    GIRLS: 'girls',
};

export const StripChatSourceId = {
    SEARCH_NATIVE: 'search-native',
    SEARCH_BANNER: 'search-banner',
};
